import {jsx as _jsx} from "react/jsx-runtime";import {Add as AddIcon} from '@mui/icons-material'
import * as React from 'react'
import useBreakpoint from '../../../../hooks/useBreakpoint'
import {Breakpoint} from '../../../../types/constEnums'
import ProviderRowActionButton from './ProviderRowActionButton'








const ConnectButton = (props) => {
  const isDesktop = useBreakpoint(Breakpoint.SIDEBAR_LEFT)

  const {
    submitting,
    onConnectClick,
    connectButtonText = 'Connect',
    connectButtonIcon = _jsx(AddIcon, {} )
  } = props

  return (
    _jsx(ProviderRowActionButton, {

      onClick: onConnectClick,
      palette: "warm",
      waiting: submitting,
 children: 
      isDesktop ? connectButtonText : connectButtonIcon
    }, "linkAccount")
  )
}

export default ConnectButton
